import Button from "@clayui/button";
import React, { useEffect, useState } from "react";
import "./DeclarationStyles.css";
import { useMyContext } from "../context/SubmissionContext";
import { SubmissionResponse } from "../dto/dto";
import { useNavigate } from "react-router-dom";
import { FormPdfView } from "./FormPdfView";
import { PDFDownloadLink } from "@react-pdf/renderer";

const DeclarationSuccessPreview = ({ ...props }) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { submissionForm, setSubmitResponseValue } = useMyContext();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [submissionResponse, setFormData] = useState<SubmissionResponse | null>(
    null
  );
  const navigate = useNavigate();

  useEffect(() => {
      const nav = performance.getEntriesByType("navigation")[0] as PerformanceNavigationTiming;
      const alreadyHandled = sessionStorage.getItem("kdr-reload-handled");
      if (nav && nav.type === "reload" && !alreadyHandled) {
          sessionStorage.setItem("kdr-reload-handled", "true");
          navigate(`${localStorage.getItem("kdr-form-pathname")}`);
      } else {
          sessionStorage.removeItem("kdr-reload-handled");
          setFormData(submissionForm);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="p-4 kdr-form-widget">
      <div>
        <h2 className="text-xl font-bold">Formularz zgłoszeniowy KDR</h2>
      </div>
      <div>
        <h3 className="text-lg mt-4">
          Deklaracja została przyjęta do rozpatrzenia. Potwierdzenie zostało
          wysłane na skrzynkę e-mail.
        </h3>
      </div>
      <div>
        <Button
          displayType="primary"
          onClick={() =>
            navigate(`${localStorage.getItem("kdr-form-pathname")}`)
          }
        >
          Wyślij kolejny
        </Button>
      </div>
      <div className="mt-2">
        <div>
          <PDFDownloadLink
            document={<FormPdfView submissionForm={submissionForm} />}
            fileName="wydruk_formularza.pdf"
          >
            {({ blob, url, loading, error }) =>
              loading ? (
                "Ładowanie dokumentu..."
              ) : (
                <>
                  <Button displayType="primary">Pobierz PDF</Button>
                </>
              )
            }
          </PDFDownloadLink>
        </div>
      </div>
        {/* <form
          name="potwierdzenieZlozeniaDeklaracji"
          method="post"
        >
          <fieldset>
            <legend className="aui-fieldset-legend">
              <span className="kdr-legend">Dane Podmiotu</span>
            </legend>
            <div className="row">
              <div className="column">
                <label>Data złożenia deklaracji</label>
                <input
                  disabled
                  style={{ width: "215px" }}
                  value={submissionResponse?.declarationDate}
                />
              </div>
              <div className="column">
                <label>Nazwa</label>
                <textarea
                  disabled
                  style={{ width: "480px", resize: "none" }}
                  value={submissionResponse?.authorityName}
                />
              </div>
            </div>

            <div className="row">
              <div className="column">
                <label>REGON</label>
                <input
                  disabled
                  style={{ width: "159px" }}
                  value={submissionResponse?.regon}
                />
              </div>
              <div className="column">
                <label>KRS</label>
                <input
                  disabled
                  style={{ width: "159px" }}
                  value={submissionResponse?.krs}
                />
              </div>
              <div className="column">
                <label>Strona WWW</label>
                <input
                  disabled
                  style={{ width: "159px" }}
                  value={submissionResponse?.website}
                />
              </div>
              <div className="column">
                <label>Liczba oddziałów</label>
                <input
                  disabled
                  style={{ width: "159px" }}
                  value={submissionResponse?.branchCount}
                />
              </div>
            </div>
          </fieldset>

          <fieldset>
            <legend className="aui-fieldset-legend">
              <span className="kdr-legend">
                Dane adresowe siedziby Podmiotu
              </span>
            </legend>

            <div className="row">
            </div>

            <div className="row">
              <div className="column">
                <label>Kod pocztowy</label>
                <input
                  disabled
                  style={{ width: "152px" }}
                  value={submissionResponse?.zipcode}
                />
              </div>
              <div className="column">
                <label>Miejscowość</label>
                <input
                  disabled
                  style={{ width: "515px" }}
                  value={submissionResponse?.territorialRange}
                />
              </div>
            </div>

            <div className="row">
              <div className="column">
                <label>Ulica</label>
                <input
                  disabled
                  style={{ width: "332px" }}
                  value={submissionResponse?.streetId}
                />
              </div>
              <div className="column">
                <label>Numer budynku</label>
                <input
                  disabled
                  style={{ width: "159px" }}
                  value={submissionResponse?.buildingNumber}
                />
              </div>
              <div className="column">
                <label>Numer lokalu</label>
                <input
                  disabled
                  style={{ width: "160px" }}
                  value={submissionResponse?.apartmentNumber}
                />
              </div>
            </div>
          </fieldset>

          <fieldset>
            <legend className="aui-fieldset-legend">
              <span className="kdr-legend">Dane osoby do kontaktu</span>
            </legend>
            <div className="row">
              <div className="column">
                <label>Nazwisko</label>
                <input
                  disabled
                  style={{ width: "333.5px" }}
                  value={submissionResponse?.lastName}
                />
              </div>
              <div className="column">
                <label>Imię</label>
                <input
                  disabled
                  style={{ width: "333.5px" }}
                  value={submissionResponse?.name}
                />
              </div>
            </div>
            <div className="row">
              <div className="column">
                <label>Nr telefonu</label>
                <input
                  disabled
                  style={{ width: "152px" }}
                  value={submissionResponse?.phoneNumber}
                />
              </div>
              <div className="column">
                <label>Email</label>
                <input
                  disabled
                  style={{ width: "516px" }}
                  value={submissionResponse?.email}
                />
              </div>
            </div>
          </fieldset>

          <fieldset>
            <legend className="aui-fieldset-legend">
              <span className="kdr-legend">Dane proponowanego uprawnienia</span>
            </legend>
            <div className="row">
              <div className="column">
                <label>Rodzaj uprawnienia - wielkość w %</label>
                <input
                  disabled
                  value={submissionResponse?.privilegePercent}
                />
              </div>
            </div>
            <div className="row">
              <div className="column">
                <label>Rodzaj uprawnienia - opis</label>
                <textarea
                  disabled
                  style={{ width: "680px", resize: "none" }}
                  value={submissionResponse?.privilegeDescription}
                />
              </div>
            </div>
            <div className="row">
              <div className="column">
                <label>Termin obowiązywania od</label>
                <input
                  disabled
                  value={submissionResponse?.validityStart}
                />
              </div>
              <div className="column">
                <label>Termin obowiązywania do</label>
                <input
                  disabled
                  value={submissionResponse?.validityEnd}
                />
              </div>
            </div>
            <div className="row">
              <div className="column">
                <label>Zasięg terytorialny</label>
                <input
                  disabled
                  value={submissionResponse?.territorialRange}
                />
              </div>
            </div>
          </fieldset>
        </form> */}
    </div>
  );
};

export default DeclarationSuccessPreview;
